
class FormatHelper {

    // Date format to UTC, used to format dates to be sent as backend filters
    dateFormatUTC(dateStr, endOfDay = false) {

        if (dateStr == null)
            return null

        const date = new Date(dateStr);

        if (endOfDay) {
            date.setHours(23, 59, 59, 999); // Réglez l'heure à la fin de la journée locale
        } else {
            date.setHours(0, 0, 0, 0); // Réglez l'heure au début de la journée locale
        }

        const localDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
        return localDate.toISOString().slice(0, 19); // Convertir en UTC et formater en 'YYYY-MM-DDTHH:MM:SS'
    }

    // format date
    formatDate(date) {
        return date ? new Date(date).toLocaleString('fr-FR') : null;
    }

    // Return an array of balises
    balisesResponseFormat(data) {

        var balisesList = [];

        data.forEach(balise => {
            balisesList.push(this.baliseInfoFormat(balise));
        });

        return balisesList;
    }

    // Return an array of badges
    badgesResponseFormat(data) {

        var badgesList = [];

        data.forEach(badge => {
            badgesList.push(this.badgeInfoFormat(badge));
        });

        return badgesList;
    }

    // Return an array of badge profiles
    badgeProfilesResponseFormat(data) {

        var profilesList = [];

        data.forEach(profile => {
            profilesList.push(this.badgeProfileFormat(profile));
        });

        return profilesList;
    }

    contactsResponseFormat(data) {

        var contactsList = [];

        data.forEach(contact => {
            contactsList.push(this.contactInfoFormat(contact));
        });

        return contactsList;
    }

    // Return an array of corridorings
    corridoringsFormat(data) {

        var corridoringList = [];

        data.forEach(corridoring => {
            corridoringList.push(this.corridoringInfoFormat(corridoring));
        });

        return corridoringList;
    }

    // Return an array of geofencings
    geofencingsFormat(data) {
        const list = [];
        if (!Array.isArray(data)) return list;

        data.forEach(geofencing => {
            const formatted = this.geofencingInfoFormat(geofencing);
            if (formatted) list.push(formatted);
        });

        return list;
    }


    // Return an array of mission members
    missionMembersFormat(data) {

        var membersList = [];

        data.forEach(member => {
            membersList.push(this.missionMemberInfoFormat(member));
        });

        return membersList;
    }

    // Return an array of groups array including balises with the last latitude set
    groupsBalisesArrayFormat(data) {

        var groupsBalises = [];

        // Order data to get groups filled with balises
        data.forEach(balise => {

            // if balise has no last latitude set, then don't do nothing and don't add it
            if (balise.lastLatitude !== null) {
                var stringGroupId = null;
                var groupId = null;
                var groupName = null;

                // if balise has group, then us its data, if not then use groupless data
                if (balise.group != null) {
                    stringGroupId = balise.group.id.toString();
                    groupId = balise.group.id;
                    groupName = balise.group.name;
                }
                else {
                    stringGroupId = "0";
                    groupId = 0;
                    groupName = "Sans groupe";
                }

                // if group array doesn't exist, then create it
                if (typeof groupsBalises[stringGroupId] === 'undefined') {
                    groupsBalises[stringGroupId] =
                    {
                        groupId: groupId,
                        groupName: groupName,
                        balises: []
                    }
                }

                // push the balise data to the group array
                groupsBalises[stringGroupId].balises.push(this.baliseInfoFormat(balise));
            }
        });
        return groupsBalises;
    }

    // Return an array balise info
    baliseInfoFormat(data) {

        var baliseInfo = [];

        let lastSeen = data.lastPositionDate;
        let lastLatitude = data.lastLatitude;
        let lastLongitude = data.lastLongitude;
        let lastBattery = data.lastBattery;
        let lastAddress = data.lastAddress;
        let lastSpeed = data.lastSpeed;
        let lastPowerVoltage = data.lastPowerVoltage;
        let powerConnected = data.powerConnected;
        let lastLevelGPS = data.lastLevelGPS;
        let lastLevelGSM = data.lastLevelGSM;
        let lastTemperature = data.lastTemperature;
        let alarms = data.alarms ? this.baliseAlertsFormat(data.alarms) : null;


        baliseInfo = {
            id: data.id,
            imei: data.baliseId,
            name: data.name,
            immat: data.registrationPlate,
            icon: data.icon,
            vehicle: data.vehicle,
            color: data.color,
            make: data.make,
            model: data.model,
            vin: data.vin,
            comment: data.comment,
            type: data.type,
            lastSeen: lastSeen,
            displayLastSeen: this.formatDate(data.lastPositionDate),
            lastLatitude: lastLatitude,
            lastLongitude: lastLongitude,
            lastBattery: lastBattery,
            lastPowerVoltage: lastPowerVoltage,
            powerConnected: powerConnected,
            lastAddress: lastAddress,
            lastSpeed: lastSpeed,
            lastLevelGPS: lastLevelGPS,
            lastLevelGSM: lastLevelGSM,
            lastTemperature: lastTemperature,
            updatedAt: data.lastPositionDate,
            createdAt: this.formatDate(data.serviceDate),
            immatriculation: data.vehicleImmatriculation,
            remoteMonitoring: data.remoteMonitoring,
            free: data.free,
            allowedSMS: data.commercialPackage ? data.commercialPackage.allowedSMS : false,
            commercialPackageId: data.commercialPackageId,
            groupName: "Sans groupe",
            groupId: null,
            commercialPackage: data.commercialPackage,
            blocageDemarreur: data.blocageDemarreur,
            ongoingAlarm: data.ongoingAlarm,
            corridoringId: data.corridoringId,
            featureCorridoring: data.featureCorridoring,
            alarms: alarms,
            digitalIOs: data.digitalIOs,
            parkingLat: data.parkingLat,
            parkingLong: data.parkingLong,
            atlantId: data.atlantId,
            client: data.client,
            status: data.status,
            plusAContact: data.plusAContact,
            geofencingId: data.geofencingId,
        };

        // if balise has group, then us its data, if not then use groupless data
        if (data.group != null) {
            baliseInfo["groupName"] = data.group.name;
            baliseInfo["groupId"] = data.group.id;
        }

        return baliseInfo;
    }


    // Return an array badge info
    badgeInfoFormat(data) {

        if (!data)
            return null

        var badgeInfo = [];

        let number = data.number == null ? "Aucune donnée" : data.number;
        let ref = data.ref == null ? "Aucune donnée" : data.ref;
        let profile = data.badgeProfileId == null ? "Aucune donnée" : this.badgeProfileFormat(data.badgeProfile);


        badgeInfo = {
            id: data.id,
            number: number,
            firstName: data.firstName,
            lastName: data.lastName,
            ref: ref,
            profile: profile,
            disabled: data.disabled
        };

        return badgeInfo;
    }

    // Return an array badge profile info
    badgeProfileFormat(data) {

        var profileInfo = [];

        let name = data.name == null ? "Aucune donnée" : data.name;

        profileInfo = {
            id: data.id,
            name: name
        };

        return profileInfo;
    }


    contactInfoFormat(data) {

        if (!data)
            return null

        var contactInfo = [];


        contactInfo = {
            id: data.id,
            name: data.name,
            type: data.type,
            contact: data.contact
        };

        return contactInfo;
    }

    // Return an array corridoring info
    corridoringInfoFormat(data) {
        if (!data) return null;

        let name = data.name == null ? "Aucune donnée" : data.name;

        return {
            id: data.id ?? null,
            name,
            startAddress: data.startAddress ?? "",
            endAddress: data.endAddress ?? "",
            distance: data.distance > 2000000 ? null : Math.round(data.distance / 1000 * 10) / 10,
        };
    }

    // Return a geofencing info
    geofencingInfoFormat(data) {
        if (!data) return null;

        const name = data.name == null ? "Aucune donnée" : data.name;

        return {
            id: data.id ?? null,
            name,
        };
    }


    // Return an array mission member info
    missionMemberInfoFormat(data) {

        if (!data)
            return null

        var missionMemberInfo = [];

        missionMemberInfo = {
            id: data.id,
            firstName: data.firstName,
            lastName: data.lastName,
            verificationCode: data.verificationCode
        };

        return missionMemberInfo;
    }


    //Return Last X positions of balise
    balisePingsFormat(data) {
        var balisePings = []
        data.forEach(position => {

            var id = position.id;
            var latitude = position.latitude;
            var longitude = position.longitude;
            var battery = position.battery;
            var temperature = position.temperature;
            var address = position.address;
            var speed = position.speed;
            var direction = position.direction;
            var levelGPS = position.levelGPS;
            var levelGSM = position.levelGSM;
            var powerVoltage = position.powerVoltage;
            var createdAt = position.createdAt;
            var updatedAt = this.formatDate(position.updatedAt);
            var positionDate = this.formatDate(position.date);
            var baliseId = position.baliseId;

            balisePings.push(
                {
                    id: id,
                    latitude: latitude,
                    longitude: longitude,
                    battery: battery,
                    temperature: temperature,
                    address: address,
                    speed: speed,
                    direction: direction,
                    levelGPS: levelGPS,
                    levelGSM: levelGSM,
                    powerVoltage: powerVoltage,
                    date: positionDate,
                    createdAt: createdAt,
                    updatedAt: updatedAt,
                    baliseId: baliseId,
                    alarms: position.alarms == null ? null : position.alarms,
                    dOut1: position.dOut1,
                    canbusData: position.canbusData ?? null,
                }
            )
        })
        return balisePings
    }


    // Return an array drive info
    driveInfoFormat(data) {

        const padWithZero = (number) => number.toString().padStart(2, '0')

        let duration = data.startDate && data.endDate ? Math.floor(((new Date(data.endDate) - new Date(data.startDate)) / 1000) / 3600) + "h" + padWithZero(Math.floor((((new Date(data.endDate) - new Date(data.startDate)) / 1000) % 3600) / 60)) : ""

        let driveInfo = {
            id: data.id,
            startAddress: data.startAddress,
            endAddress: data.endAddress,
            startCity: data.startCity,
            endCity: data.endCity,
            displayStartDate: this.formatDate(data.startDate),
            displayEndDate: this.formatDate(data.endDate),
            duration: duration,
            startDate: data.startDate,
            endDate: data.endDate,
            distance: data.distance > 2000000 ? null : Math.round(data.distance / 1000 * 10) / 10,
            baliseId: data.baliseId,
            maxSpeed: data.maxSpeed,
            balise: data.balise ? this.baliseInfoFormat(data.balise) : null
        }

        return driveInfo;
    }


    //Return Last X drives of balise
    baliseDrivesFormat(data) {
        var baliseDrives = []
        data.forEach(driveData => {

            baliseDrives.push(
                this.driveInfoFormat(driveData)
            )
        })
        return baliseDrives
    }


    //Return Last X alerts of balise
    baliseAlertsFormat(data) {
        let alarms = []
        data.forEach(alarm => {

            let id = alarm.id;
            let latitude = alarm.latitude;
            let longitude = alarm.longitude;
            let battery = alarm.battery;
            let address = alarm.address;
            let speed = alarm.speed;
            let direction = alarm.direction;
            let powerVoltage = alarm.powerVoltage;
            let createdAt = alarm.createdAt;
            let updatedAt = this.formatDate(alarm.updatedAt);
            let date = this.formatDate(alarm.date);
            let alertName = alarm.alarmType ? alarm.alarmType.name : null;
            let balise = alarm.balise == null ? null : this.baliseInfoFormat(alarm.balise)

            alarms.push(
                {
                    id: id,
                    latitude: latitude,
                    longitude: longitude,
                    battery: battery,
                    address: address,
                    speed: speed,
                    direction: direction,
                    powerVoltage: powerVoltage,
                    date: date,
                    createdAt: createdAt,
                    updatedAt: updatedAt,
                    alertName: alertName,
                    alarmType: alarm.alarmTypeId,
                    //alarmType: alarm.alarmType? alarm.alarmType : null,
                    data: alarm.data,
                    balise: balise
                }
            )
        })
        return alarms
    }


    // Return an array coordinates for the given balises list
    getCoords(data) {

        var coordinates = [];

        data.forEach(balise => {

            // if balise has no last latitude set, then don't do nothing and don't add it
            if (balise.lastLatitude !== null) {

                // push the coordiates data to the array
                coordinates.push([
                    balise.lastLatitude,
                    balise.lastLongitude
                ]);
            }
        });
        return coordinates;
    }


    getChartTemperatureData(data) {

        var result = [
            ['Date', 'Température']
        ];

        data.forEach(pos => {
            result.push([this.formatDate(pos.date), pos.temperature]);
        });

        return result;

    }

    getChartSpeedData(data) {

        var result = [
            ['Date', 'Vitesse']
        ];

        data.forEach(pos => {
            result.push([this.formatDate(pos.date), pos.speed]);
        });

        return result;

    }

    // Return an array of billings
    billingsResponseFormat(data) {

        var clientsBillings = [];

        data.forEach(client => {

            let billing = [];

            let packs = { "1": null, "2": null, "3": null, "4": null };

            client.balises.forEach(balise => {

                if (packs[String(balise.commercialPackage.id)] == null) {
                    packs[String(balise.commercialPackage.id)] =
                    {
                        packageAmount: 1,
                        remoteMonitAmount: 0,
                        name: balise.commercialPackage.name,
                        packagePrice: balise.commercialPackage.price,
                        remoteMonitPrice: balise.commercialPackage.remoteMonitoringPriceAdd
                    }
                }
                else {
                    packs[String(balise.commercialPackage.id)].packageAmount += 1;
                }

                if (balise.remoteMonitoring) {
                    packs[String(balise.commercialPackage.id)].remoteMonitAmount += 1;
                }

            });

            let total = 0;

            if (packs["1"] != null) {
                billing.push(packs["1"])
                total = (total.toFixed(2) * 100 + (packs["1"].packageAmount * packs["1"].packagePrice).toFixed(2) * 100 + (packs["1"].remoteMonitAmount * packs["1"].remoteMonitPrice).toFixed(2) * 100) / 100;
            }

            if (packs["2"] != null) {
                billing.push(packs["2"])
                total += packs["2"].packageAmount * packs["2"].packagePrice + packs["2"].remoteMonitAmount * packs["2"].remoteMonitPrice
            }

            if (packs["3"] != null) {
                billing.push(packs["3"])
                total += packs["3"].packageAmount * packs["3"].packagePrice + packs["3"].remoteMonitAmount * packs["3"].remoteMonitPrice
            }

            if (packs["4"] != null) {
                billing.push(packs["4"])
                total += packs["4"].packageAmount * packs["4"].packagePrice + packs["4"].remoteMonitAmount * packs["4"].remoteMonitPrice
            }


            clientsBillings.push(
                {
                    billings: billing,
                    client: client,
                    clientTotal: total
                });

        });

        return clientsBillings;
    }


    // Return an array of billings sub totals
    subTotalsBillingsResponseFormat(data) {

        let billing = [];

        let packs = { "1": null, "2": null, "3": null, "4": null };

        data.forEach(client => {

            client.balises.forEach(balise => {

                if (packs[String(balise.commercialPackage.id)] == null) {
                    packs[String(balise.commercialPackage.id)] =
                    {
                        packageAmount: 1,
                        remoteMonitAmount: 0,
                        name: balise.commercialPackage.name,
                        packagePrice: balise.commercialPackage.price,
                        remoteMonitPrice: balise.commercialPackage.remoteMonitoringPriceAdd
                    }
                }
                else {
                    packs[String(balise.commercialPackage.id)].packageAmount += 1;
                }

                if (balise.remoteMonitoring) {
                    packs[String(balise.commercialPackage.id)].remoteMonitAmount += 1;
                }

            });

        });

        if (packs["1"] != null) {
            billing.push(packs["1"])
        }

        if (packs["2"] != null) {
            billing.push(packs["2"])
        }

        if (packs["3"] != null) {
            billing.push(packs["3"])
        }

        if (packs["4"] != null) {
            billing.push(packs["4"])
        }

        return billing;
    }

}

export default new FormatHelper();